import { render } from "./roleIndex.vue?vue&type=template&id=70ae0274"
import script from "./roleIndex.vue?vue&type=script&lang=js"
export * from "./roleIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__